import { lazy } from 'react';

const CustomTicketing = lazy(() => import('./CustomTicketing'));

export default CustomTicketing;
